import { createRequestData, getRequestData } from "../../Utility/apiHelper"
import * as actionType from './type';
import { handleValidateCodevalue, i18HashMapKey } from "../../Utility/constant";

export const handleRequestGetAllClientData = (clientid, isFirstTime) =>  async(dispatch, getState) => {
    
    try {

        dispatch({
            type: actionType?.REQUEST_GLOBALIZE_DATA,
            payload: true
        })
        const {data} = await getRequestData(`${process.env.REACT_APP_BASE_URL}i18?clientId=${clientid}`);

       
        const currentHashMapData = {};

        if(data?.length > 0) {  
            data.forEach(item => {
                currentHashMapData[item?.code] = item?.value ? item?.value : item?.code;
            });

            dispatch({
                type: actionType?.RECEIVED_GLOBALIZE_DATA,
                payload: {data, currentHashMapData}
            });

            if (typeof window !== 'undefined' && window.localStorage && Object.keys(currentHashMapData).length > 0) {
                try {
                    localStorage.setItem(i18HashMapKey, JSON.stringify(currentHashMapData));
                } catch {
                }
            }
        } else {
            dispatch({
                type: actionType?.RECEIVED_GLOBALIZE_DATA,
                payload: {data: data || [], currentHashMapData: getState()?.internationalise?.currentHashMapData || {}}
            });
        }

    } catch(error) {

        dispatch({
            type: actionType?.RECEIVED_GLOBALIZE_DATA,
            payload: {data: [], currentHashMapData: getState()?.internationalise?.currentHashMapData || {}}
        });

        dispatch({
            type: actionType?.REQUEST_GLOBALIZE_DATA,
            payload: false
        });

    }
}

export const handleRequestUpdatelientData = (clientid) =>  (dispatch) => {
    
    try {

        const {data} = getRequestData(`${process.env.REACT_APP_BASE_URL}i18?clientId=${clientid}`);


    } catch(error) {

    }
}


export const handleRequestAddClientData = (payload, enqueueSnackbar,internationalise, isAdd) => async(dispatch) => {
    try {

        dispatch({
            type: actionType?.REQUEST_GLOBALIZE_DATA,
            payload: true
        })

        const response = await createRequestData(payload, `${process.env.REACT_APP_BASE_URL}i18`);


        if(response?.status == 200) {

            dispatch(handleRequestGetAllClientData(payload?.clientId, false));

            if(isAdd) {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_CREATED_SUCCESSFULLY"), {variant: "success"});

            } else {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_UPDATED_SUCCESSFULLY"), {variant: "success"});

            }

        } else {

            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: "error"});

            dispatch({
                type: actionType?.REQUEST_GLOBALIZE_DATA,
                payload: false
            })
        }

        

    } catch(error) {

        enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: "error"});

        dispatch({
            type: actionType?.REQUEST_GLOBALIZE_DATA,
            payload: false
        })


    }
}
